import Web3 from 'web3';
import MoUContractABI from '../contracts/MoUContract.json';

let web3;
let mouContract;

const initWeb3 = async () => {
  if (typeof window.ethereum !== 'undefined') {
    web3 = new Web3(window.ethereum);
    try {
      await window.ethereum.request({ method: 'eth_requestAccounts' });
    } catch (error) {
      console.error("User denied account access");
      throw error;
    }
  } else if (typeof window.web3 !== 'undefined') {
    web3 = new Web3(window.web3.currentProvider);
  } else {
    console.error('Non-Ethereum browser detected. You should consider trying MetaMask!');
    throw new Error('No web3 provider detected');
  }

  const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
  if (!contractAddress) {
    console.error("Contract address is not set in environment variables");
    throw new Error('Contract address is not set');
  }

  console.log('Using contract address:', contractAddress);
  mouContract = new web3.eth.Contract(MoUContractABI.abi, contractAddress);
  return true;
};

export async function getMoUDetails(mouId) {
  try {
    if (!web3 || !mouContract) {
      await initWeb3();
    }
    
    console.log('Fetching MoU details for ID:', mouId);
    const mou = await mouContract.methods.getMoU(mouId).call();
    console.log('Raw MoU data from contract:', mou);

    // Ensure createdAt is properly extracted and converted
    const createdAt = mou[2] ? mou[2].toString() : '0';
    console.log('Extracted createdAt:', createdAt);

    // Assuming mou is an array with indices corresponding to struct fields
    const formattedMou = {
      id: mouId,
      initiator: mou[0],
      counterparty: mou[1],
      createdAt: createdAt, // Ensure this field is included
      status: ['Pending', 'Completed', 'Cancelled'][parseInt(mou[3])],
      initiatorSigned: mou[4],
      counterpartySigned: mou[5],
      content: mou[6],
      // Add other fields as necessary
    };
    console.log('Formatted MoU data:', formattedMou);

    return formattedMou;
  } catch (error) {
    console.error('Error fetching MoU details:', error);
    throw error;
  }
}

export async function signMoU(mouId, account) {
  try {
    if (!web3 || !mouContract) {
      await initWeb3();
    }
    
    console.log('Signing MoU:', mouId, 'by account:', account);
    const result = await mouContract.methods.signMoU(mouId).send({ from: account });
    console.log('MoU signed successfully:', result);
    return result;
  } catch (error) {
    console.error('Error signing MoU:', error);
    throw error;
  }
}

export async function getMoUs(account) {
  try {
    if (!web3 || !mouContract) {
      const initialized = await initWeb3();
      if (!initialized) {
        throw new Error("Failed to initialize Web3 or contract");
      }
    }
    
    const mouCount = await mouContract.methods.mouCount().call();
    const mous = [];

    for (let i = 1; i <= mouCount; i++) {
      const mou = await getMoUDetails(i);
      if (mou.initiator.toLowerCase() === account.toLowerCase() || 
          mou.counterparty.toLowerCase() === account.toLowerCase()) {
        mous.push(mou);
      }
    }

    return mous;
  } catch (error) {
    console.error('Error fetching MoUs:', error);
    throw new Error(`Failed to fetch MoUs: ${error.message}`);
  }
}

export async function createMoU(fromAddress, counterpartyAddress, initiatorName, counterpartyName) {
  try {
    if (!web3) {
      await initWeb3();
    }

    console.log("Checking accounts...");
    const accounts = await web3.eth.getAccounts();
    console.log("Accounts:", accounts);

    if (accounts.length === 0) {
      throw new Error("No connected accounts. Please connect your wallet.");
    }

    console.log("Connected account:", accounts[0]);
    console.log("From address:", fromAddress);

    if (fromAddress.toLowerCase() !== accounts[0].toLowerCase()) {
      throw new Error("Connected account doesn't match the from address.");
    }

    const result = await mouContract.methods.createMoU(counterpartyAddress, initiatorName, counterpartyName).send({ from: fromAddress });
    return {
      success: true,
      transactionHash: result.transactionHash,
      mouId: result.events.MoUCreated.returnValues.mouId,
      message: `MoU creation initiated between ${initiatorName} and ${counterpartyName}`
    };
  } catch (error) {
    console.error('Error creating MoU:', error);
    return {
      success: false,
      error: error.message || "An unknown error occurred"
    };
  }
}